import { dealService, dispensaryService } from '../../../../../services'
import { getTargetAudience } from '../../../../../helpers/targetAudiences'
import dynamic from 'next/dynamic';
import { serverLocationDetector } from '../../../../../utils/locationDetector';
import Footer from '../../../../../components/Layouts/Footer';
const Layout = dynamic(() => import('../../../../../components/_App/Layout'))
const Error404 = dynamic(() => import('../../../../../pages/404'))
const InternalServerError = dynamic(() => import('../../../../../templates/InternalServerError'))
const DealTemplate = dynamic(() => import('../../../../../templates/Deal'))

export default function BusinessDealDetails(props) {

   

    if(props.code === 500){
        return <InternalServerError />
    }

    return (
        <Layout
            isAppleMobile = {props.isAppleMobile}
            seo={{
                description: `${props.deal.description}`,
                image: props.dispensary.logo ? props.dispensary.logo : '/static/icons/favicon.png',
                title: `${props.deal.name} at ${props.dispensary.name} | Weedzly`,
                url:'https://weedzly.com/'
            }}
        >
            <DealTemplate 
                {...props}
            />
            <Footer />
        </Layout>
    )

}

export async function getServerSideProps(context){

    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

    try {

        let businessSlug = context.params.slug
        let dealId = context.params.deal
        
        await serverLocationDetector(context)
        const [ deal, dispensary ] = await Promise.all([
            dealService.getBySlug(businessSlug, dealId),
            dispensaryService.getDetailsPage(businessSlug), 
        ])

        return {
            props: { 
                isAppleMobile,
                deal,
                dispensary
            }
        } 
    } catch({code, message}) {
        if(code && code === 404){
            return {
                notFound: true,
              }
        }
        return {
            props:{
                isAppleMobile,
                code,
                message,
            }
            
        } 
    }
}
